import { render, staticRenderFns } from "./TaxesPanel.vue?vue&type=template&id=ad1f9ebc&scoped=true&"
import script from "./TaxesPanel.vue?vue&type=script&lang=js&"
export * from "./TaxesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1f9ebc",
  null
  
)

export default component.exports